var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAffiliates = function SvgAffiliates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#currentColor",
    d: "M15.975 7.377a3 3 0 1 1 4.243 4.243 3 3 0 0 1-4.243-4.243M5.964 5.05a4.071 4.071 0 1 1 5.757 5.758A4.071 4.071 0 0 1 5.964 5.05M3.57 13.965a3.62 3.62 0 0 0-1.06 2.558H2.51v3.62h12.667v-3.62a3.62 3.62 0 0 0-3.62-3.618H6.129c-.96 0-1.88.382-2.558 1.06M17.419 19.599h4.073v-2.85a2.85 2.85 0 0 0-2.85-2.85h-1.223v5.699999999999999"
  })));
};
export default SvgAffiliates;